/**

 * 默认提示语配置汇总
 * 职责: 汇总所有分类的提示语常量
 */
import type { TemplateType } from '../../../types/ai-analysis-types';
import { ANALYSIS_PROMPTS } from './analysisPrompts';
import { COPYWRITING_PROMPTS } from './copywritingPrompts';
import { STRATEGY_PROMPTS } from './strategyPrompts';

export const DEFAULT_PROMPTS: Record<TemplateType, string> = {
    ...ANALYSIS_PROMPTS,
    ...COPYWRITING_PROMPTS,
    ...STRATEGY_PROMPTS
} as Record<TemplateType, string>;



